module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av692-8130b515e99a8c940c4e575a5672769f.jpg";